import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=3840efda&scoped=true"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=3840efda&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3840efda",
  null
  
)

export default component.exports